import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { selectUser, selectData, setData } from '../../services/store/userSlice';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Calendar } from "primereact/calendar";
import { Column } from 'primereact/column';
import { Panel } from 'primereact/panel';
import { SelectButton } from 'primereact/selectbutton';
import { toast } from "react-toastify";
import { capitalize } from '../../services/utility/helper';
import { leaveService } from '../../services/extensions';
import { Status, LeaveStatus } from '../../common/util/constants';
import {
    generateRandomColor, processMonthlyLeaves, getAbsenceCodesLocationWise, getLeaveTypesByUserLocation,
    chartData, basicOptionsbasicOptions, lineChartOptions, yearChartData
} from './controllers/employee-controller';
import { Review, Draft, Approved, Reject, LeaveBalanceChart } from './views'
import NewAbsenceRequest from './NewAbsenceRequest';
import { LeaveYearChart } from './views/leave-year-chart';
import { utitService } from '../../services/util';
import './styles/style.scss';
import { InputSwitch } from 'primereact/inputswitch';
import { Tooltip } from 'primereact/tooltip';

const MyLeaveDashboard = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector(selectUser);
    const userData = useSelector(selectData);
    const optionsSelect = ['Draft', 'Review', 'Approved', 'Rejected'];
    const [dates, setDates] = useState(new Date());
    const [leaveTab, setLeaveTab] = useState('Draft');
    const [isNew, setIsNew] = useState(false);
    const [displayCharts, setDisplayCharts] = useState(true);
    const [leaveChartData, setLeaveChartData] = useState({});
    const [allLeavesByUser, setAllLeavesByUser] = useState([]);
    const [absenceCodesByLocation, setAbsenceCodesByLocation] = useState([]);
    const [userLeaveData, setUserLeaveData] = useState([]);
    const [draft, setDraft] = useState([]);
    const [review, setReview] = useState([]);
    const [approved, setApproved] = useState([]);
    const [rejected, setRejected] = useState([]);

    const [isLbGridView, setIsLbGridView] = useState(false);
    const [isYlbGridView, setIsYlbGridView] = useState(false);

    const [leaves, setLeaves] = useState([]);
    const [leaveBalData, setLeaveBalData] = useState({});

    const [leaveTeken, setLeaveTaken] = useState({ labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'], datasets: [] });

    const [absenceCode, setAbsenceCode] = useState({});
    const leaveColor = [{ SL: '#00ba0d' }, { CL: '#f4b444' }, { RH: '#92f444' }, { EL: '#44f4e3' }, { ML: '#cf44f4' }, { BL: '#ff0000' }, { LWP: '#f45d44' }, { PL: '#4445f4' },];

    useEffect(() => {
        getLeaves();
        getYearlyApprovedLeaves();
        onLoad();
    }, [dates]);

    useEffect(() => {
        if (leaveTeken.datasets) {
            if (leaveTeken?.datasets?.filter(x => x === 0).length === 0) {
                setIsYlbGridView(true)
            }
        }
    }, [leaveTeken.datasets])

    useEffect(() => {
        const currentRoute = window.location.pathname;
        if (currentRoute && currentRoute === '/leaves/new-absence') {
            setIsNew(true);
        }
    }, [window.location.pathname]);

    const onLoad = async () => {
        if (user) {
            const ulData = await getUserLeaves(user.id);
            const data = await getAbsenceCodesLocationWise(ulData, userLeaveData, dispatch, selectData, user);
            setAbsenceCodesByLocation(data.AbsenceCodesByLocation);
            const ltData = await getLeaveTypesByUserLocation(dispatch, data.userData);
            setLeaveBalData({ ...chartData });
            getDraftLeaves()
        }
    }
    const updateYearlyChartData = (data) => {
        let leaveObj = [];
        if (userData) {
            const tookLeave = data.filter(x => x.status === LeaveStatus.APPROVED && x.status !== Status.ARCHIVE) || [];
            const ult = userData.userAbsenceCodes;
            for (let item of ult) {
                const obj = {
                    label: item.code,
                    data: processMonthlyLeaves(tookLeave, item),
                    fill: true,
                    borderColor: leaveColor[item.code],
                    backgroundColor: leaveColor[item.code],
                    tension: .4
                }
                leaveObj.push(obj);
            }
            setLeaveTaken({ ...leaveTeken, datasets: leaveObj });
        }
    }

    const getUserLeaves = (id) => {
        console.log("fetching leave data....")
        return leaveService.getLeavesByUser(id).then(resp => {
            const obj = { labels: resp.data.data.map(x => x.code), datasets: [] };
            const leaveTypes = ['accrued', 'balance', 'taken'];
            const color = { 'accured': '#ffe6aa', 'balance': '#9ad0f5', 'taken': '#ffb1c1' }
            for (let x of leaveTypes) {
                    obj.datasets.push({ label: capitalize(x), backgroundColor: color[x], data: resp.data.data.map(y => { return (y[x]) }) })
            }
            setLeaveChartData(obj);
            const leaveData = resp.data.data.map(x=>({...x,balance: (x.balance < 0 ? 0 : x.balance)}));
            setUserLeaveData(leaveData);
            return leaveData;
        })
    };

    const getYearlyApprovedLeaves = async () => {
        try {
            const resp = await leaveService.getAllYearLeaves(utitService.dateParser(dates, 'YYYY-MM-DD'), 2);
            const data = resp.data.data;
            updateYearlyChartData(data);
            return data;
        } catch (error) {
            console.error("Error fetching leaves:", error); // Added error logging
            return [];
        }
    };

    const getLeaves = async () => {
        try {
            const resp = await leaveService.getAllMonthLeaves(utitService.dateParser(dates, 'YYYY-MM-DD'));
            const data = resp.data.data;
            setReview(data.filter(x => x.status === LeaveStatus.REVIEW && x.status !== Status.ARCHIVE) || []);
            setApproved(data.filter(x => x.status === LeaveStatus.APPROVED && x.status !== Status.ARCHIVE) || []);
            setRejected(data.filter(x => x.status === LeaveStatus.REJECTED && x.status !== Status.ARCHIVE) || []);
            setLeaves(data);
            // updateYearlyChartData(data);
            return data;
        } catch (error) {
            console.error("Error fetching leaves:", error); // Added error logging
            return [];
        }
    };

    const getDraftLeaves = () => {
        leaveService.getAllLeaves({ status: LeaveStatus.DRAFT }).then(resp => {
            const data = resp.data.data;
            const draftLeaves = data.filter(x => x.status === LeaveStatus.DRAFT && x.status !== Status.ARCHIVE) || [];
            setDraft(draftLeaves);
        }).catch(error => {
            console.log("Error", error);
        })

    };


    const reLoad = () => {
        getDraftLeaves();
        getLeaves();
        getYearlyApprovedLeaves();
    }


    const renderAllLeaves = () => {
        return (<>
            <Panel className='p-0'>
                <div className='flex display_block'>
                    <div className='col-12 md:col-6'>
                        <span className="p-buttonset button_pd">
                            <Button label="Draft" className={leaveTab === "Draft" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setLeaveTab('Draft')} badge={draft.length} badgeClassName="p-badge-danger" />
                            <Button label="Review" className={leaveTab === "Review" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setLeaveTab('Review')} badge={review.length} badgeClassName="p-badge-danger" />
                            <Button label="Approved" className={leaveTab === "Approved" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setLeaveTab('Approved')} badge={approved.length} badgeClassName="p-badge-danger" />
                            <Button label="Rejected" className={leaveTab === "Rejected" ? 'p-button-primary' : 'p-button-outlined p-button-inactive'} onClick={() => setLeaveTab('Rejected')} badge={rejected.length} badgeClassName="p-badge-danger" />
                        </span>
                    </div>
                    <div className='col-12 md:col-6 flex justify-content-end'>
                        <Button icon='pi pi-replay' tooltip='Reload Leaves' className='p-button-sm ml-2 p-button-primary mr-1' onClick={() => { getDraftLeaves(); getLeaves() }} />
                        {!['Draft'].includes(leaveTab) &&
                            <Calendar id="monthpicker" value={dates} onChange={(e) => setDates(e.value)} view="month" dateFormat="mm-yy" yearNavigator yearRange={"2010:" + new Date().getFullYear().toString()} showIcon />
                        }
                        <Button label='New Absence Request' icon='pi pi-calendar-plus' className='p-button-sm ml-1 p-button-secondary' onClick={() => navigate('/leaves/new-absence')} />
                    </div>
                </div>
                <div className='ess-border ess-table mt-1 p-2'>
                    {leaveTab === "Draft" && <Draft leaves={draft || []} reload={reLoad} />}
                    {leaveTab === "Review" && <Review leaves={review || []} reload={reLoad} />}
                    {leaveTab === "Approved" && <Approved leaves={approved || []} reload={reLoad} />}
                    {leaveTab === "Rejected" && <Reject leaves={rejected || []} reload={reLoad} />}
                </div>
            </Panel>
        </>)
    }

    const renderLeaveBalanceGrid = () => {
        return (<div className='ess-border ess-table mt-1 p-2 leave_height'>
            <DataTable value={userLeaveData} 
            responsiveLayout="scroll" 
            stripedRows scrollable scrollHeight="250px" 
            virtualScrollerOptions={{ itemSize: 25 }}>
                <Column field="absenceCode" header="Absence Code" body={(r, o) => <><strong>{r?.code}</strong><em> ({r?.title})</em></>} />
                {/* <Column field="carryForward" header={<span>
                    Carry forward
                    <i className='cf-icon pi pi-info-circle pl-1' data-pr-tooltip="From previous year" data-pr-position="top" data-pr-at="right+5 top" data-pr-my="left center-2" /><Tooltip target=".cf-icon" />
                </span>} style={{ width: '125px', textAlign: 'center' }} body={(r) => r.carryForward ? r.carryForward : 0} /> */}
                <Column field="carryForward" header='Carry forward' style={{ width: '125px', textAlign: 'center' }} body={(r) => r.carryForward ? r.carryForward : 0} />
                <Column field="accured" header="Accrued" style={{ width: '60px', textAlign: 'center' }} />
                <Column field="taken" header="Taken" style={{ width: '60px', textAlign: 'center' }} />
                <Column field="balance" header="Balance" style={{ width: '60px', textAlign: 'center' }} />
            </DataTable>
        </div>)
    }

    const renderYearlyLeaveBalanceGrid = () => {
        return (<div className='ess-border ess-table mt-1 p-2'>
            <DataTable value={userLeaveData} responsiveLayout="scroll" stripedRows scrollable scrollHeight="250px" virtualScrollerOptions={{ itemSize: 25 }}>
                <Column field="absenceCode" header="Absence Code" body={(r, o) => <><strong>{r?.code}</strong><em> ({r?.title})</em></>} />
                <Column field="accured" header="Accrued" style={{ width: '100px', textAlign: 'center' }} />
                <Column field="taken" header="Taken" style={{ width: '100px', textAlign: 'center' }} />
                <Column field="carryForward" header="Carry Forward" style={{ width: '100px', textAlign: 'center' }} />
                <Column field="balance" header="Balance" style={{ width: '100px', textAlign: 'center' }} />
            </DataTable>
        </div>)
    }

    return (<div>
        {isNew ? <>
            <NewAbsenceRequest back={() => setIsNew(false)} leaves={draft || []} reload={reLoad} />
        </> : <>
            {/* <div className='grid leave-dashboard-chip' >
                <div className='col pt-2 dashboard-chip-label' ><strong>Anlytics</strong></div>
                <div className='col-fixed dashboard-chip-switch'><InputSwitch checked={displayCharts} onChange={(e) => setDisplayCharts(e.value)} /></div>
            </div> */}
            <div className='col p-0 pt-2 pb-4' style={{fontSize: '22px', fontWeight: 'bold'}}>Leave Statistics</div>
            {displayCharts && <div className='grid flex flex-wrap leave-chart ess-page leave-statistics'>
                <div className='col-6'>
                    <Panel className='dashboard-panel' header={<div className=''>
                        <div className='grid'>
                            <div className='col-fixed grid' style={{ width: '160px', textAlign: 'right' }}>
                                <div className='col pt-3' style={{ textAlign: 'right' }}>Chart</div>
                                <div className='col' style={{ textAlign: 'center' }}><InputSwitch checked={isLbGridView} onChange={(e) => setIsLbGridView(e.value)} /></div>
                                <div className='col pt-3' style={{ textAlign: 'left' }}>Grid</div>
                            </div>
                        </div>
                    </div>}>
                        {isLbGridView ? <>
                            {renderLeaveBalanceGrid()}
                        </> : <>
                            <LeaveBalanceChart data={leaveChartData} options={basicOptionsbasicOptions} />
                        </>}
                    </Panel>
                </div>
                <div className='col-6'>
                    <Panel className='dashboard-panel' header={<div className=''>
                        <div className='grid'>
                            <div className='col pt-3' style={{ marginBottom: '10px' }}>{isYlbGridView ? 'Leave Statistics Chart' : 'Leave Yearly Statistics'} </div>
                            {/* <div className='col-fixed grid' style={{ width: '160px', textAlign: 'right' }}>
                                <div className='col pt-3' style={{ textAlign: 'right' }}>Chart</div>
                                <div className='col' style={{ textAlign: 'center' }}><InputSwitch checked={isYlbGridView} onChange={(e) => setIsYlbGridView(e.value)} /></div>
                                <div className='col pt-3' style={{ textAlign: 'left' }}>Grid</div>
                            </div> */}
                        </div>
                    </div>}>
                        {/* {isYlbGridView ? <>
                            {renderYearlyLeaveBalanceGrid()}
                        </> : <> */}
                        <LeaveYearChart data={leaveTeken} options={lineChartOptions} />
                        {/* </>} */}
                    </Panel>
                </div>
            </div>}
            <div className='grid ess-page p-0 display_content'>
                <div className='col'>
                    {renderAllLeaves()}
                </div>
            </div>
        </>}
    </div>);
}

export default MyLeaveDashboard;